import Chip from "Components/Common/Chip/Chip";
import { IAreaSelectionUtil } from "Interfaces/Utils/IAreaSelectionUtil";
import { IChipUtil } from "Interfaces/Utils/IChipUtil";
import { resolve } from "inversify-react";
import { Area } from "Models/Areas/Area";
import * as React from "react";
import { connect } from "react-redux";
import Types from "ServiceProvider/Types";
import { IAreaState } from "Store/Areas/AreaState";
import { IApplicationState } from "Store/Store";
import styles from "./AreaChip.scss";

interface IProps {
    area: Area;
    filteredArea?: Area;
    className?: string;
    areaState: IAreaState;
    size?: string;
    maxPathLength?: number;
}

interface IState {
    area: Area;
    filteredArea?: Area;
    areas: Area[];
    path: string[];
}

const mapStateToProps = (state: IApplicationState) => ({
    areaState: state.areaState
});

export class AreaChip extends React.Component<IProps, IState> {
    @resolve(Types.IAreaSelectionUtil) public areaSelectionUtil: IAreaSelectionUtil;
    @resolve(Types.IChipUtil) public chipUtil: IChipUtil;

    constructor(props: IProps) {
        super(props);

        this.state = {
            area: props.area,
            areas: [],
            path: [],
            filteredArea: props.filteredArea
        };
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState> {
        const partialState: Partial<IState> = {};

        if (nextProps.areaState.companyAreas && nextProps.areaState.companyAreas !== prevState.areas) {
            partialState.areas = nextProps.areaState.companyAreas;
        }

        if (nextProps.filteredArea !== prevState.filteredArea) {
            partialState.filteredArea = nextProps.filteredArea;
        }

        return partialState;
    }

    public render() {
        const { path, tooltip } = this.chipUtil.getAreaChip(this.state.area, this.state.areas, this.state.filteredArea, this.props.maxPathLength);

        return (
            <Chip className={this.props.className} wrapperClassName={styles.background} path={path} tooltip={tooltip} size={this.props.size} />
        );
    }
}

export default connect(mapStateToProps, null)(AreaChip);


// WEBPACK FOOTER //
// ./src/Components/Common/Chip/AreaChip.tsx